var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxSelect = function SvgCheckboxSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4794EF",
    rx: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "checkbox_select_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M2 2h20v20H2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#checkbox_select_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.958 14.625 7.062-7.062a.8.8 0 0 1 .584-.25.8.8 0 0 1 .583.25q.25.25.25.593 0 .344-.25.594l-7.646 7.667a.8.8 0 0 1-.583.25.8.8 0 0 1-.583-.25L5.79 12.833a.78.78 0 0 1-.24-.593.85.85 0 0 1 .261-.594.81.81 0 0 1 .594-.25q.343 0 .594.25z"
  }))));
};
export default SvgCheckboxSelect;